module.exports = "/_next/static/images/favorite_icon-a7a663396c5788b34de62840771c52b9.svg";